import { generateCRUD, useHttp } from '@Libs/http';

const medicalSpecialtiesApi = generateCRUD('medical-specialties');

export default medicalSpecialtiesApi;

const KEY_MEDICAL_SPECIALTIES = 'KEY_MEDICAL_SPECIALTIES';
export const useMedicalSpecialties = () => useHttp(KEY_MEDICAL_SPECIALTIES, ({ cmsHttp }) => medicalSpecialtiesApi(cmsHttp).find());
